<div class="row">
  <div class="p-1" [ngClass]="isCollapsed ? 'col-3' : 'col-12'">
    <div class="card mb-2">
      <div class="card-header">
        <span class="client-header-content">Clients</span>
        <div (click)="onGridCollapse()">
          <ng-container *ngIf="!isCollapsed">
            <span class="fas fa-angle-double-left"></span>
          </ng-container>
          <ng-container *ngIf="isCollapsed">
            <span class="fas fa-angle-double-right"></span>
          </ng-container>
        </div>
      </div>

      <div class="card-body my-auto" *ngIf="loadingClientList">
        <app-loading [busy]="loadingClientList" [busyText]="'Loading clients...'"></app-loading>
      </div>

      <div class="card-body my-auto d-sm-flex" *ngIf="!loadingClientList">
        <div class="table-responsive">
          <table class="table" mdbTable hover="true" small="true">
            <thead *ngIf="!isCollapsed">
              <tr>
                <th>
                  <div class="md-form">
                    <input
                      [(ngModel)]="searchText"
                      mdbInput
                      name="searchText"
                      type="search"
                      id="searchText"
                      placeholder="Search"
                      style="font-size: small; border-bottom-color: #7b7f82"
                    />
                  </div>
                </th>
                <th></th>
                <th></th>
              </tr>
              <tr class="table-header">
                <th class="sortable" [appSort]="filterableClients" data-name="fullName">Client</th>
                <th class="sortable" [appSort]="filterableClients" data-order="desc" data-name="nextStepDescription">Next Step</th>
                <th style="min-width: 130px">Last Completed Step</th>
                <th>Last Note</th>
                <th
                  class="sortable"
                  style="min-width: 125px"
                  [appSort]="filterableClients"
                  data-order="desc"
                  data-name="lastUpdatedDateTime"
                  data-type="date"
                >
                  Last Updated
                </th>
              </tr>
            </thead>

            <thead *ngIf="isCollapsed">
              <tr>
                <th>
                  <div class="md-form">
                    <input
                      [(ngModel)]="searchText"
                      mdbInput
                      name="searchText"
                      type="search"
                      id="searchText"
                      placeholder="Search"
                      style="font-size: small; border-bottom-color: #7b7f82"
                    />
                  </div>
                </th>
              </tr>
              <tr class="table-header">
                <th class="sortable" [appSort]="filterableClients" data-name="fullName">Client</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let clientInfo of filterableClients | filter: searchText">
                <tr (click)="onClientSelect(clientInfo.userId)" [ngClass]="{ 'selected-client': clientInfo.userId === selectedClientId }">
                  <td class="d-sm-flex" style="justify-content: space-between">
                    {{ clientInfo.fullName }}
                  </td>
                  <ng-container *ngIf="!isCollapsed">
                    <td>
                      <strong>{{ clientInfo.nextStepDescription }}</strong>
                    </td>
                    <td class="text-muted small">
                      {{ clientInfo.lastCompletedStepDescription }}
                    </td>
                    <td>
                      {{ clientInfo.lastNote }}
                    </td>
                    <td>{{ clientInfo.lastUpdatedDateTime | date: "dd MMM yyyy" }}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="col-9">
    <div class="row">
      <div class="col-12">
        <ng-container *ngIf="isCollapsed && selectedClientId == null">
          <div class="col-12 p-1">
            <div class="card">
              <div class="card-header my-auto">Please select a client to continue offboarding them</div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="infoLoading">
          <div class="card-body my-auto">
            <app-loading [busy]="infoLoading" [busyText]="'Loading client...'"></app-loading>
          </div>
        </ng-container>
        <ng-container *ngIf="!infoLoading">
          <ng-container *ngIf="selectedClientId != null">
            <div class="row">
              <div class="col-12 p-1">
                <div class="card">
                  <div class="card-header my-auto d-sm-flex" style="justify-content: space-between">
                    <div>
                      <strong>{{ offboardingClient.fullName }}</strong> ({{ offboardingClient.userId }})
                      <mdb-badge *ngIf="!offboardingClient?.isActive" color="black">Archived</mdb-badge>
                      <div class="text-muted small">
                        Created: {{ offboardingClient.clientCreatedDate | date: "dd MMM yyyy" }} -
                        {{ offboardingClient.clientCreatedDate | daysAgo }}
                      </div>
                    </div>
                    <div class="d-sm-flex" style="justify-content: space-between">
                      <app-loading [busy]="loadingProfile"></app-loading>
                      <ng-container *ngIf="!loadingProfile">
                        <button mdbBtn color="trakly-action" class="relative waves-light btn-sm btn" (click)="onEditProfileClick()">
                          Edit Profile
                        </button>
                      </ng-container>

                      <ng-container *ngIf="canArchive()">
                        <button mdbBtn color="trakly1" class="relative waves-light btn-sm btn" (click)="archiveClient()">Archive</button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row">
                  <ng-container *ngIf="offboardingClient.isActive">
                    <app-offboarding-categories-steps
                      [offboardingClient]="offboardingClient"
                      (stepNoteAdded)="handleNoteCreated($event)"
                      class="col-5 p-1"
                    >
                    </app-offboarding-categories-steps>
                  </ng-container>
                  <div class="col-7 p-1">
                    <div class="card">
                      <div class="card-header">Notes</div>
                      <div class="card-body">
                        <app-offboarding-notes
                          [clientId]="selectedClientId"
                          [createdByUserId]="createdByUserId"
                          [newNote]="newNote"
                          (noteCreateError)="parseAndDisplayError($event)"
                        ></app-offboarding-notes>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <app-user-profile-modal
    [selectedUserDetails]="selectedUserFullDetails"
    [(showModal)]="showUserProfileModal"
    (onModelChange)="handleUserProfileUpdated($event)"
  ></app-user-profile-modal>
</div>
<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
